/* eslint-disable @typescript-eslint/no-unused-vars */
import { hudAssets } from "assets/cdn/hud";
import CountdownV2 from "components/CountdownV2";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { HudDipItem } from "interfaces";
import moment from "moment";
import { Fragment, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { onOpenHudDip } from "redux/slices";
import { getHudAnalyticsValues, mapHudItemToDip } from "../../helper";
import {
	hudDipTimer,
	hudDipTimerText,
	HudImageContainer,
	HudItemContainer,
	HudTimerAnimation,
	HudTimerContainer,
	HudVisual,
	Ribbon,
	RibbonText
} from "../styles";

export const HudItem = ({
	hudItem,
	onExpire
}: {
	hudItem: HudDipItem;
	onExpire: () => void;
}) => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { getImage } = useImagePath("cdn");
	const { dipConfig } = hudItem;
	const ribbonImage = getImage(hudAssets.ribbon);
	const backgroundImage = getImage(hudAssets.background);
	const showTimer = useMemo(() => {
		return (
			dipConfig?.dip?.timer === true &&
			nowTime &&
			nowTime < moment(dipConfig?.timerExpirationDate)
		);
	}, [nowTime, dipConfig?.dip?.timer, dipConfig?.timerExpirationDate]);

	const onClick = () => {
		const dip = mapHudItemToDip(hudItem);
		if (!dip) {
			return;
		}

		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "limited_deal_hud_click",
			event_type: "limited_deal_hud",
			action: "offer_click",
			source: "limited_deal",
			...getHudAnalyticsValues(hudItem, nowTime),
			page_location: location.pathname
		});

		dispatch(
			onOpenHudDip({
				dip,
				timerExpirationDate: dipConfig?.timerExpirationDate
			})
		);
	};

	return (
		<HudItemContainer onClick={onClick}>
			<HudVisual>
				{showTimer && dipConfig?.timerExpirationDate && (
					<HudTimerContainer>
						<HudTimerAnimation className="hud-offer-timer">
							<CountdownV2
								text=""
								icon={<Fragment />}
								startTime={nowTime}
								endTime={dipConfig.timerExpirationDate}
								onEnd={onExpire}
								hideTimerDisplayOnEnd={true}
								style={hudDipTimer}
								timerStyle={hudDipTimerText}
							/>
						</HudTimerAnimation>
					</HudTimerContainer>
				)}
				<HudImageContainer $backgroundImage={backgroundImage}>
					<img
						className="hud-offer-image"
						src={dipConfig?.dip?.hudIconImageUrl}
						alt=""
					/>
				</HudImageContainer>
				<Ribbon $backgroundImage={ribbonImage}>
					<RibbonText>{dipConfig?.dip?.hudText}</RibbonText>
				</Ribbon>
			</HudVisual>
		</HudItemContainer>
	);
};
